import { render, staticRenderFns } from "./AddGoogleAdsChannel.vue?vue&type=template&id=a4f771a6"
import script from "./AddGoogleAdsChannel.vue?vue&type=script&lang=js"
export * from "./AddGoogleAdsChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports